import { render, staticRenderFns } from "./backups.vue?vue&type=template&id=ffc5cc8c&scoped=true"
import script from "./backups.vue?vue&type=script&lang=js"
export * from "./backups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc5cc8c",
  null
  
)

export default component.exports